// 引入所有的svg的文件
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const contexts = require.context("../icons", true, /\.svg$/);
requireAll(contexts);
